import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioTravelExtensionEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioTravelExtensionEntity
